import styled from "styled-components";
import { Steps, Icon } from "antd";

export const FlowSteps = styled(Steps)`
  &&& {
    background-color: white;
    flex-direction: column;
    height: 445px;
    @media only screen and (max-width: 991.92px) {
      height: auto;
    }
    .ant-steps-item-finish {
      cursor: ${props => (props.disableSteppers ? "default" : "pointer")}
    }
    .ant-steps-item-process {
      cursor: ${props => (props.disableSteppers ? "default" : "pointer")};
    //  .ant-steps-item-content .ant-steps-item-title >div:first-child {
    //     background-color: #006778;
    //   }
    }

    .ant-steps-item-finish {
      text-align: left;
      transition: all 0.3s linear;
      .ant-steps-item-description {
        display: "none";
      }
      .ant-steps-item-title {
        display: flex;
        > div:first-child {
          // background-color: ${props =>
            props.theme.backgroundColor.primaryColor};
        }
      }
    }
    @media only screen and (max-width: 991.92px) {
      display: flex;
      flex-direction: row;
      margin-bottom: 0.75rem;
    }
  }
`;

export const ExchangeStep = styled(Steps.Step)`
  &&& {
    height: 145px;
    margin-right: 0 !important;
    background-color: white;
    border: 1px solid #dcdcdc;
    margin-bottom: 0.5rem;
    &:last-of-type {
      margin-bottom: 0;
    }
    overflow: visible;
    .ant-steps-item-tail {
      display: none;
    }
    .ant-steps-item-icon {
      display: none;
    }
    .ant-steps-item-content {
      position: relative;
      width: 100%;
      height: 100%;
      margin: 0 auto;
      @media only screen and (min-width:991px){
        position: absolute;
      }
    }
    .ant-steps-item-title {
      width: 100%;
      height: 100%;
      padding-left: 1.25rem;
      padding-right: 1.25rem !important;
      position: relative;
      padding: 0;
      padding-right: 0 !important;
    }
    // .ant-steps-item-title :nth-child(3) {
    //   padding-top: 0rem;
    //   padding-bottom: 0rem;
    //   height: fit-content;
    //   margin-top: 25px;
    //   padding-left: 1.56rem;
    // }
    .ant-steps-item-description {
      padding-left: 1.5625rem;
      /* // padding-right: 1.25rem; */
      font-family: ${props => props.theme.fontFamily.berkeleyStdBold};
      line-height: ${props => props.theme.lineHeight.oneP25};
      letter-spacing: ${props => props.theme.letterSpacing.point4};
      z-index: 3;
      position: absolute;
      color: #727272;
      font-size: 16px;
      top: 72px;
      left: 0;
      right: 0;
      margin-top: 0px;
      @media only screen and (min-width: 768px) and (max-width: 991px) {
        margin-top: 0px;
        top: 26px;
      }
      @media only screen and (min-width: 320px) and (max-width: 767px) {
        margin-top: 0px;
        top: 26px;
      }
      bottom: 0%;
      /* background: white;   */
      & span {
        display: inline-block;
        // margin-top: 50px;
        @media only screen and (min-width: 768px) and (max-width: 991px) {
          //margin-top: 5px;
          margin-left: 0px;
        }
        @media only screen and (min-width: 320px) and (max-width: 767px) {
          //margin-top: 5px;
          margin-left: 0px;
        }
      }
    }
    .ant-steps-item-title:after {
      display: none;
    }
    box-shadow: ${props => {
      if (props.active) {
        return "5px 6px 10px 0 rgba(0, 0, 0, 0.1)";
      }
      return "none";
    }};
    @media only screen and (max-width: 991.92px) {
      flex-basis: 18.5%;
      height: auto;
      text-align: center;
      margin-right: 0.5rem !important;
      &:nth-child(3) {
        margin-right: 0rem !important;
      }
      .ant-steps-item-content {
        padding-bottom: 0.75rem;
        overflow: initial;
        @media only screen and (min-width: 767px) and (max-width: 992px) {
          padding-left: 1.3rem;
        }
      }
      .ant-steps-item-title {
        position: initial !important;
        line-height: 16px;
      }
      .ant-steps-item-description {
        max-width: initial;
        display: ${props => (props.active ? "block" : "none")};
        font-size: 12px;
        padding-left: 0rem;
      }
      &.ant-steps-item-process {
        text-align: left;
        height: 100%;
        flex-basis: ${props => (props.active ? "63%" : "15%")};
        */transition: all 0.3s linear;
        .ant-steps-item-description {
          display: ${props => (props.active ? "block" : "none")};
        }
        @media only screen and (max-width: 767px) {
          height: 55px;
        }
      }
      &.ant-steps-item-finish {
        text-align: left;
        flex-basis: ${props => (props.active ? "63%" : "15%")};
        transition: all 0.3s linear;
        .ant-steps-item-description {
          display: "none";
        }
        .ant-steps-item-title {
          display: flex;
          justify-content: center;
          > div:first-child {
            background-color: ${props =>
              props.theme.backgroundColor.primaryColor};
          }
        }
      }
      &.ant-steps-item-wait {
        .ant-steps-item-description {
          display: none;
        }
      }
    }
    @media only screen and (max-width: 991px) {
      &:last-of-type {
        margin-bottom: 0.5rem;
      }
      .ant-steps-item-finish {
        text-align: left;
        flex-grow: ${props => (props.active ? 1 : "0.001")};
        transition: all 0.3s linear;
        .ant-steps-item-description {
          display: none;
        }
        .ant-steps-item-title {
          display: flex;
          justify-content: center;
          > div:first-child {
            background-color: ${props =>
              props.theme.backgroundColor.primaryColor};
          }
        }
      }
      &.ant-steps-item-wait {
        .ant-steps-item-description {
          display: none;
        }
      }
    }
    @media only screen and (max-width: 480px) {
      &:last-of-type {
        margin-bottom: 0.5rem;
      }
      &.ant-steps-item-process {
        text-align: left;
        flex-grow: ${props => (props.active ? 1 : "7")};
        transition: all 0.3s linear;
        > div:nth-child(3) > div:nth-child(2) > span {
          display: ${props => (props.active ? "block" : "none")};
        }
        .ant-steps-item-description {
          display: block;
        }
      }
      &.ant-steps-item-finish {
        text-align: left;
        flex-grow: ${props => (props.active ? 1 : "0.001")};
        transition: all 0.3s linear;
        .ant-steps-item-description {
          display: none;
        }
        .ant-steps-item-title {
          display: flex;
          justify-content: center;
          > div:first-child {
            background-color: ${props =>
              props.theme.backgroundColor.primaryColor};
          }
        }
      }
      &.ant-steps-item-wait {
        .ant-steps-item-description {
          display: none;
        }
      }
      .ant-steps-item-title {
        line-height: 16px;
        padding-left: 0.5rem;
        padding-right: 0.5rem !important;
      }
      .ant-steps-item-description {
        font-size: 12px;
        padding-left: 0.5rem;
        padding-right: 0.5rem;
        padding-bottom: 0px;
      }
      .ant-steps-item-tail:after {
        display: none !important;
      }
    }
  }
`;

export const StepBand = styled.div`
  background-color: ${props => {
    if (props.active) {
      return props.theme.backgroundColor.primaryColor;
    }
    return props.theme.backgroundColor.layoutDark;
  }};
  z-index: 5;
  position: absolute;
  height: 100%;
  width: 6px;
  left: 0;
  & + div {
    padding-top: 1rem;
  }
  @media only screen and (max-width: 991.92px) {
    height: 3px;
    width: 100%;
  }
  @media only screen and (max-width: 480px) {
    & + div {
      font-size: 10px;
      padding-top: 0.5rem;
    }
  }
`;

export const StepNumber = styled.div`
  color: ${props =>
    props.active
      ? props.theme.fontColors.primary
      : props.theme.fontColors.blur};
  line-height: normal;
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};  
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  margin-top: ${props => props.theme.spacing.paddings.webBase};
  background-color: ${props => props.theme.backgroundColor.layoutLight};
  z-index: 2;
  padding-left: 1.5625rem;
  height: fit-content;
  width: fit-content;
  @media only screen and (max-width: 991px) {
    padding-left: 0rem;
    font-size: ${props => props.theme.fontSize.quaternary};
    margin-top: 0px;
    padding-top: 0.75rem;
    padding-bottom: 0.25rem;
    transform: ${props => {
      if (props.active && props.activeStep === props.allKey) {
        return "translate(0)";
      }
      return "translate(-50%, -50%)";
    }};
    position: ${props => {
      if (props.active && props.activeStep === props.allKey) {
        return "static";
      }
      return "absolute";
    }};
    top: 40%;
    left: 50%;
  }
`;

export const ActiveIcon = styled(Icon)`
  z-index: 3;
  position: absolute;
  font-size: 25px;
  color: #ffffff;
  right: -26px;
  top: 45%;
  transform: translate(-45%, 0);
  display: ${props => {
    if (props.active) {
      return "block";
    }
    return "none";
  }};
  @media only screen and (min-width: 320px) and (max-width: 374px) {
    font-size: 16px;
    color: white;
    left: 50%;
    top: 3.7rem;
    right: unset;
    transform: translate(-50%, 0) rotate(90deg);
  }
  @media only screen and (min-width: 360px) and (max-width: 373px) {
    top: 3rem;
  }
  @media only screen and (min-width: 374px) and (max-width: 768px) {
    font-size: 16px;
    color: white;
    left: 50%;
    top: 3rem;
    right: unset;
    transform: translate(-50%, 0) rotate(90deg);
  }
  @media only screen and (min-width: 767px) and (max-width: 991.92px) {
    font-size: 16px;
    color: white;
    top: 3.3rem;
    left: 50%;
    right: unset;
    transform: translate(-45%, 0) rotate(90deg);
  }
`;
